/** @format */

import React, { useRef } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  ExcelPrint,
  Pdf,
  PrintElem,
} from "../../../../components/functions/Print";
import print from "../../../../icons/print.png";
import { NavLink } from "react-router-dom";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import { monthDays } from "../../../../components/functions/Month";
import { user_data } from "../../../../components/functions/usr";
import { useReactToPrint } from "react-to-print";
import $ from "jquery";

const RAVOTXOJI_TABLE_ID = "ravotxojiTable";
const RAVOTXOJI_HOURS = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
const RAVOTXOJI_DAY_COLUMN_WIDTH = 78;
const RAVOTXOJI_MONTH_NAMES = [
  "yan",
  "fev",
  "mar",
  "apr",
  "may",
  "iyun",
  "iyul",
  "avg",
  "sen",
  "okt",
  "noy",
  "dek",
];
const RAVOTXOJI_TIME_COLUMN_WIDTH = 75;

const Table3 = ({
  data,
  month,
  dateColumns,
  setDate,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const conponentPDF = useRef();
  const tableDateColumns = getTableDateColumns(month, dateColumns);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  const overHandler = (index) => {
    $("tr.tr1 td:nth-child(" + (index + 3) + ")").addClass("hovertd");
    $("tr.tr2 td:nth-child(" + (index + 2) + ")").addClass("hovertd");
  };

  const leaveHandler = (index) => {
    $("tr.tr1 td:nth-child(" + (index + 3) + ")").removeClass("hovertd");
    $("tr.tr2 td:nth-child(" + (index + 2) + ")").removeClass("hovertd");
  };

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'></div>
        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf(RAVOTXOJI_TABLE_ID)} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Ravotxoji", month, RAVOTXOJI_TABLE_ID)}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div
        className='table-responsive tableFixHead'
        id='tableFlexibles'
        style={{ height: selectedRowKeys > 0 ? "37vh" : "80vh" }}>
        <div ref={conponentPDF} style={{ width: "100%" }}>
          <table
            className='table table-bordered table-style td-pointer vertical-hover-table ravotxoji-web-table'
            data-excel-range={Array.isArray(dateColumns) ? "true" : undefined}
            id={RAVOTXOJI_TABLE_ID}>
            <thead>
              <tr className='ravotxoji-title-row'>
                <th colSpan={tableDateColumns.length + 2} scope='col'>
                  Ravotxoja g/u dagi suv sarflari m<sup>3</sup>/s
                </th>
              </tr>

              <tr>
                <th
                  scope='col'
                  className='sticky st1'
                  style={{
                    width: RAVOTXOJI_TIME_COLUMN_WIDTH,
                    minWidth: RAVOTXOJI_TIME_COLUMN_WIDTH,
                  }}>
                  Soat
                </th>

                <th
                  scope='col'
                  className='sticky ravotxoji-source-cell'
                  style={{ left: RAVOTXOJI_TIME_COLUMN_WIDTH }}>
                  Zarafshon
                </th>

                {tableDateColumns
                  .map((column, i) => {
                    return (
                      <th
                        key={i}
                        className='ravotxoji-date-cell'
                        style={{
                          width: RAVOTXOJI_DAY_COLUMN_WIDTH,
                          minWidth: RAVOTXOJI_DAY_COLUMN_WIDTH,
                          whiteSpace: "nowrap",
                        }}
                        onMouseLeave={() => leaveHandler(i)}
                        onMouseOver={() => overHandler(i)}>
                        {user_data() ? (
                          user_data().region_id == 8 ? (
                            <NavLink
                              to='/ravotxoji/add'
                              onClick={() => setDate && setDate(column.date)}>
                              {column.label}
                            </NavLink>
                          ) : (
                            column.label
                          )
                        ) : (
                          column.label
                        )}
                      </th>
                    );
                  })}
              </tr>
            </thead>

            <tbody>
              {data
                ? [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20, 21, 22, 23, 24,
                  ].map((i) => {
                    if (i % 2 == 1) {
                      return (
                        <tr key={i} className='tr1'>
                          <td
                            rowSpan={2}
                            className='sticky st1'
                            style={{
                              width: RAVOTXOJI_TIME_COLUMN_WIDTH,
                              minWidth: RAVOTXOJI_TIME_COLUMN_WIDTH,
                              whiteSpace: "nowrap",
                              verticalAlign: "middle",
                            }}>
                            {i < 10 ? "0" : ""}
                            {i}-00
                          </td>

                          <td
                            className='text-center sticky ravotxoji-source-cell'
                            style={{ left: RAVOTXOJI_TIME_COLUMN_WIDTH }}>
                            Ravotxoji
                          </td>

                          {tableDateColumns
                            .map((_, ind) => {
                              return (
                                <td
                                  key={ind}
                                  onMouseLeave={() => leaveHandler(ind)}
                                  onMouseOver={() => overHandler(ind)}
                                  onClick={() =>
                                    setSelectedRowKeys &&
                                    setSelectedRowKeys(ind + 1)
                                  }
                                  className={`ravotxoji-value-cell ${
                                    ind + 1 === selectedRowKeys ? "active" : ""
                                  }`.trim()}>
                                  {formatTableValue(
                                    data?.["r" + i]?.[ind + 1]
                                  )}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    } else {
                      return (
                        <tr key={i} className='tr2'>
                          <td
                            className='text-center sticky ravotxoji-source-cell'
                            style={{ left: RAVOTXOJI_TIME_COLUMN_WIDTH }}>
                            Ziatdin
                          </td>
                          {tableDateColumns
                            .map((_, ind) => {
                              return (
                                <td
                                  key={ind}
                                  onMouseLeave={() => leaveHandler(ind)}
                                  onMouseOver={() => overHandler(ind)}
                                  onClick={() =>
                                    setSelectedRowKeys &&
                                    setSelectedRowKeys(ind + 1)
                                  }
                                  className={`ravotxoji-value-cell ${
                                    ind + 1 === selectedRowKeys ? "active" : ""
                                  }`.trim()}>
                                  {formatTableValue(
                                    data?.["z" + (i - 1)]?.[ind + 1]
                                  )}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    }
                  })
                : null}

              {data ? (
                <tr className='ravotxoji-average-row' style={{ fontWeight: 700 }}>
                  <td
                    colSpan={2}
                    className='sticky st1 text-center'
                    style={{
                      verticalAlign: "middle",
                      background: "#fff",
                      fontWeight: 700,
                    }}>
                    O'rtacha
                  </td>

                  {tableDateColumns
                    .map((_, ind) => {
                      return (
                        <td
                          className='ravotxoji-value-cell'
                          style={{
                            width: 60,
                            maxWidth: 60,
                            minWidth: 60,
                            fontWeight: 700,
                          }}
                          key={ind}>
                          {calculateAverage(data, ind + 1)}
                        </td>
                      );
                    })}
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default Table3;

const getRavotxojiMonthName = (month) => {
  const monthIndex = parseInt(month?.slice(5, 7), 10) - 1;

  return RAVOTXOJI_MONTH_NAMES[monthIndex] || "";
};

const formatHeaderDate = (month, day) => {
  return `${day} ${getRavotxojiMonthName(month)}`;
};

const getTableDateColumns = (month, dateColumns) => {
  if (Array.isArray(dateColumns) && dateColumns.length) {
    return dateColumns;
  }

  return Array(monthDays(month))
    .fill()
    .map((_, index) => {
      const day = index + 1;

      return {
        date: `${month}-${String(day).padStart(2, "0")}`,
        day,
        month,
        label: formatHeaderDate(month, day),
      };
    });
};

const getNumberValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const number = parseFloat(String(value).replace(",", "."));
  return Number.isNaN(number) ? null : number;
};

const formatTableValue = (value) => {
  const number = getNumberValue(value);

  if (number === null) {
    return "-";
  }

  return formatNumberValue(number);
};

const formatNumberValue = (value) => {
  const rounded = Math.round((value + Number.EPSILON) * 10) / 10;

  return rounded % 1 === 0 ? Math.floor(rounded) : rounded;
};

const calculateAverage = (data, day) => {
  const values = RAVOTXOJI_HOURS.map((hour) =>
    getNumberValue(data?.["r" + hour]?.[day])
  ).filter((value) => value !== null);

  if (!values.length) {
    return "-";
  }

  const sum = values.reduce((total, value) => total + value, 0);

  return formatNumberValue(sum / values.length);
};
